export const GRAPHQL_SITE_PATH = process.env.GRAPHQL_PATH_HACHSHARA

export function convertISODateString(dateStr?: string) {
  if (!dateStr) return
  const dateObj = new Date(dateStr)
  return new Intl.DateTimeFormat("en-GB").format(dateObj)
}

export function getNonUmbracoURL({
  url,
  toDelete,
}: {
  url: string
  toDelete: string
}) {
  return url.replace(toDelete, "")
}

export type StatusTitles = {
  title: string | undefined
  id: number | null | undefined
}[]
export type EdgesArray<T> = Array<NonNullable<T>>

export type MatchedStatuses = {
  name: string | null | undefined
  id: number
  title: string | undefined
}[]

export function ensureHttps(url: string): string | undefined {
  if (!url) return
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return `https://${url}`
  }
  return url
}

/**
 * Handles numeric input by removing all non-digit characters from the input value
 * @param e - The input event
 */
export const handleNumericInput = (e: React.ChangeEvent<HTMLInputElement>) => {
  const input = e.target as HTMLInputElement
  input.value = input.value.replace(/\D/g, "")
}
